/**
 * `ListNoMatch` (DNKADM-0430): the state under a client-side list whose rows loaded but
 * none matches the toolbar search. Distinct from the screen's own empty state (nothing
 * loaded at all), which keeps its first-run copy and call to action.
 */
import { Box, Typography } from '@mui/material';
import { Icon } from '@/theme';

export function ListNoMatch({ noun, query }: { noun: string; query: string }) {
  return (
    <Box role="status" sx={{ py: 5, textAlign: 'center' }}>
      <Icon name="search" sx={{ fontSize: 40, color: 'text.disabled' }} />
      <Typography sx={{ mt: 1, fontWeight: 600 }}>
        No {noun} match “{query.trim()}”
      </Typography>
    </Box>
  );
}
